// BigDataCloud client-side reverse geocoding (free, no API key).
export async function reverseGeocode(latitude, longitude) {
  const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`;
  const r = await fetch(url);
  if (!r.ok) throw new Error("Geocoding failed");
  return r.json();
}

// Map a BigDataCloud response to the nearest supported city (by name).
export function matchSupportedCity(geo, supportedCities) {
  const names = (supportedCities || []).map((c) => (typeof c === "string" ? c : c.name));
  const candidates = [
    geo.city,
    geo.locality,
    geo.principalSubdivision,
    ...((geo.localityInfo?.administrative || []).map((a) => a.name)),
    ...((geo.localityInfo?.informative || []).map((a) => a.name)),
  ].filter(Boolean);

  for (const cand of candidates) {
    const hit = names.find((n) => n.toLowerCase() === cand.toLowerCase());
    if (hit) return hit;
  }
  for (const cand of candidates) {
    const lc = cand.toLowerCase();
    const hit = names.find((n) => lc.includes(n.toLowerCase()) || n.toLowerCase().includes(lc));
    if (hit) return hit;
  }
  return null;
}

export function detectLocationCity(supportedCities) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by your browser."));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const geo = await reverseGeocode(pos.coords.latitude, pos.coords.longitude);
          const matched = matchSupportedCity(geo, supportedCities);
          resolve({ detected: geo.city || geo.locality || geo.principalSubdivision, matched });
        } catch (e) {
          reject(e);
        }
      },
      (err) => reject(err),
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
    );
  });
}
